/**
 * This function returns object having active, prev and next slide index
 *
 * @param {Object} config - params object
 * @returns {Object} - acticeSlide/nextSlide/prevSlide indexes
 */
function getSlideIndexes(config) {
    const {activeIndex, nextIndex, prevIndex, slideCount} = config;
    let prevSlide = prevIndex;
    let nextSlide = nextIndex;
    let activeSlide = activeIndex;

    if (activeSlide > slideCount) {
        activeSlide = 0;
        prevSlide = slideCount;
        nextSlide = activeSlide + 1;
        return {
            prevSlide,
            nextSlide,
            activeSlide
        };
    }

    if (activeSlide < 0) {
        activeSlide = slideCount;
        prevSlide = slideCount - 1;
        nextSlide = 0;
        return {
            prevSlide,
            nextSlide,
            activeSlide
        };
    }

    prevSlide = activeSlide - 1 < 0 ? slideCount : activeSlide - 1;
    nextSlide = activeSlide === slideCount ? 0 : activeSlide + 1;
    return {
        prevSlide,
        nextSlide,
        activeSlide
    };
}

export default getSlideIndexes;
